import { configureStore } from "@reduxjs/toolkit";
import thunkMiddleware from "redux-thunk";
import {
  app,
  auth,
  authPoll,
  categories,
  events,
  interactive,
  myVideo,
  posts,
  video,
} from "./reducers";

const store = configureStore({
  reducer: {
    app,
    auth,
    interactive,
    authPoll,
    posts,
    events,
    categories,
    video,
    myVideo,
  },
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware().concat(thunkMiddleware);
  },
  devTools: process.env.NODE_ENV === "production" ? false : true,
});

export default store;
